import React from 'react';

import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Input from '@material-ui/core/Input';
import StyledButton from '../../common/models/Button';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import clsx from 'classnames';
import PropTypes from 'prop-types';
import { useStyles } from './grnStyles';

const Search = (props) => {
  const {
    searchQuery,
    handleSearchQuery,
    handleClearSearch,
    submitSearch,
    placeholder,
    disabled,
  } = props;
  const classes = useStyles();

  return (
    <form noValidate onSubmit={submitSearch}>
      <Grid container alignItems='center'>
        <Grid item xs={12} sm={8} lg={6}>
          <Input
            fullWidth
            disabled={disabled}
            placeholder={placeholder || 'Search here'}
            value={searchQuery}
            name='searchQuery'
            onChange={handleSearchQuery}
            onBlur={(e)=>{
              const {name, value} = e.target;
              if(typeof value === 'string' && value.trim()!== value){
                handleSearchQuery({target:{ name, value: value.trim()}})
              }
            }}
            startAdornment={<SearchIcon />}
            style={{ fontSize: '0.875rem' }}
            endAdornment={
              searchQuery && (
                <Tooltip title='Clear search' aria-label='clear'>
                  <ClearIcon
                    fontSize='small'
                    onClick={handleClearSearch}
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
              )
            }
          />
        </Grid>
        <Grid item xs={2} className={clsx(classes.pdL10, classes.pdTponLr)}>
          <StyledButton type='submit' className={classes.search}>
            Search
          </StyledButton>
        </Grid>
      </Grid>
    </form>
  );
};
Search.propTypes = {
  searchQuery: PropTypes.string,
  placeholder: PropTypes.string,
  handleSearchQuery: PropTypes.func.isRequired,
  handleClearSearch: PropTypes.func.isRequired,
  submitSearch: PropTypes.func.isRequired,
};
export default Search;
